import {$, $$, getParentElementByClassName} from "./Dom.ts";
import {fadeOutFadeIn} from "./Animate.ts";
import {initDropzone} from "./Dropzone.ts";
import {showModal} from "./Modal.ts";
import {$get} from "./Ajax.ts";
import Dropzone, {DropzoneFile, DropzoneMockFile} from "dropzone";
import {findCkeditorInstance} from "./Utils.ts";

export const initNotesForm = (container: HTMLElement | null, containerToShow: string | null = null) => {
    if (container) {
        const dropzone = $(`.dropzone`, container)
        $('.btn_ajout_pj_note', container)?.addEventListener('click', (event) => {
            handleBtnAjoutPjNoteClicked(event, container, containerToShow, dropzone)
        })
        $('.btn_ajout_pj_note', container)?.addEventListener('keyup', (event) => {
            handleBtnAjoutPjNoteClicked(event, container, containerToShow, dropzone)
        })
        $('.btn_ajout_pj_note', container)?.addEventListener('click', () => {
            if (containerToShow) {
                fadeOutFadeIn($('.btn_ajout_pj_note', container), $(containerToShow, container))
            } else {
                fadeOutFadeIn($('.btn_ajout_pj_note', container), dropzone)
            }
        })
        initDropzone(dropzone)
    }
}

function handleBtnAjoutPjNoteClicked(event: DOMEvent<HTMLElement>, container: HTMLElement, containerToShow: string | null = null, dropzone: HTMLElement | null) {
    if ((event.type === "keyup" && (event.code === "Enter" || event.code === "NumpadEnter")) || event.type === "click") {
        if (containerToShow) {
            fadeOutFadeIn($('.btn_ajout_pj_note', container), $(containerToShow, container))
        } else {
            fadeOutFadeIn($('.btn_ajout_pj_note', container), dropzone)
        }
    }
}

export const initNotes = (container: HTMLElement) => {
    $$(`.liste_note`, container).forEach((note) => {
        $('.modif_note', note)?.addEventListener('click', showNoteModal)
        $('.modif_note', note)?.addEventListener('keyup', showNoteModal)
    })
}

function showNoteModal(event: DOMEvent<HTMLElement>) {
    if ((event.type === "keyup" && (event.code === "Enter" || event.code === "NumpadEnter")) || event.type === "click") {
        const target = getParentElementByClassName(event.target, 'modif_note')
        if (target) {
            const note_id = target.dataset.id!
            const url = '/dossier/note/' + note_id + '/';
            $get(url).then(response => {
                showModal('#NoteModal', false)
                return response
            }).then((response) => {
                const data = JSON.parse(response.body);
                // Récupérer CSRF
                const token = document.querySelector('#dropzone_to_load input');
                // Changer url d'action
                let action = $('#dropzone_to_load')!.dataset.url!;
                const item_list = action.split('/');
                item_list[3] = note_id;
                action = (item_list).join("/");
                $('#dropzone_to_load')!.innerHTML = (`<form id="dropzone_form_note"
                          action="${action}" method="post"
                          class="dropzone dropzone-pj-note-modif my-2"
                          enctype="multipart/form-data"
                          data-max-file="1"
                          data-max-file-size="25">
                        ${token?.outerHTML}
                        <div class="dz-message" tabindex="0" data-dz-message>
                            <i class="remix-upload" aria-hidden="true" style="font-size: 2rem;"></i>
                            <br><span>Déposer le fichier ici</span>
                            <br><small>(1 fichier par envoi)</small>
                        </div>
                    </form>`)
                // window.CKEDITOR["note_text_" + note_id].setData(data['contenu_s'])
                // @ts-ignore
                const ckeditor = findCkeditorInstance($('#NoteModal').querySelector('#note_text').id)
                ckeditor.setData(data['contenu_s'])
                const inputLisibleInstructeurs = $<HTMLInputElement>('#note_lisible_tous_instructeurs')
                if (inputLisibleInstructeurs) inputLisibleInstructeurs.checked = !!data['lisible_instructeurs_departement'];
                const inputLisibleServicesConsultes = $<HTMLInputElement>('#note_lisible_services_consultes')
                if (inputLisibleServicesConsultes) inputLisibleServicesConsultes.checked = !!data['lisible_services_consultes'];
                const inputArchive = $<HTMLInputElement>('#note_archivee')
                if (inputArchive) inputArchive.checked = !!data['archivee'];
                initDropzone($('#dropzone_form_note'));
                const myDropzone = Dropzone.forElement("#dropzone_form_note");
                if ('piece_jointe-url' in data) {
                    let mockFile: DropzoneMockFile = {
                        name: data['piece_jointe-name'],
                        size: data['piece_jointe-size'],
                        accepted: true
                    };
                    myDropzone.options.addedfile!.call(myDropzone, (mockFile as DropzoneFile));
                    myDropzone.options.thumbnail!.call(myDropzone, (mockFile as DropzoneFile), data['piece_jointe-thumbnail']);
                }
            })
        }
    }
}
